module.exports = __webpack_public_path__ + "img/2.b2ce23b8.jpg";